import React, { ReactNode } from 'react';
import { TextInputProps, View, Text } from 'react-native';
import useStyles from './FormField.styles';

export type FormFieldProps = TextInputProps & {
  error?: boolean;
  success?: boolean;
  disabled?: boolean;
  top?: ReactNode;
  bottom?: ReactNode;
};

export const FormField: React.FC<FormFieldProps> = ({
  error = false,
  success = false,
  top,
  bottom,
  children,
  style,
  ...props
}) => {
  const s = useStyles();

  return (
    <View style={s.root}>
      {top && <Text style={s.top}>{top}</Text>}
      {children}
      {bottom && (
        <Text style={[s.bottom, error && s.textError, success && s.textSuccess, style]} {...props}>
          {bottom}
        </Text>
      )}
    </View>
  );
};
